import * as React from "react";
import { useOutletContext } from "react-router-dom";
import MobileResumePage from "./components/mobile-resume";
import WebResumePage from "./components/web-resume";

export default function ResumePage() {
	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileResumePage />
				: <WebResumePage onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
